import React from 'react';
import PaymentTabs from './payment-tabs';
import SavedCreditCards from './saved-credit-cards/saved-credit-cards';
import NewCreditCard from './new-credit-card/new-credit-card';
import { newCreditCardActions, useAppDispatch, useAppSelector } from '../../data/store';
import { CreditCardTabTabsEnum } from '../../enums/credit-card-tab';
import { PaymentTabsEnum } from '../../enums/payment-tabs-enum';
import { checkIsSubscription } from '../../domain/shopping-cart-provider';
import { getIsChina } from '../../../../../domain/hidden-data-provider';
import GrayBox from '../shared/gray-box';
import CVVInfoPopup from '../../../cart-shared-bridger-pay/ui/cvv-info-popup';

/**
 * The payment part of cart step #3.
 */
const Payment = () => {

    const dispatch = useAppDispatch();

    const selectedPaymentTab = useAppSelector(store => store.root.selectedPaymentTab);
    const selectedCreditCardTab = useAppSelector(store => store.root.selectedCreditCardTab);

    const cartData = useAppSelector(store => store.root.cartData);
    const isSubscription = checkIsSubscription(cartData);
    const isChina = getIsChina();

    let isCreditCardSelected = selectedPaymentTab === PaymentTabsEnum.CreditCard;
    const isPayPalSelected = selectedPaymentTab === PaymentTabsEnum.PayPal;
    const isAliPaySelected = selectedPaymentTab === PaymentTabsEnum.AliPay;

    if((isSubscription && isAliPaySelected) || (isChina && isPayPalSelected)){
        isCreditCardSelected = true;
    }

    const isZeroPurchase = cartData.priceData.totalPrice < 1 && !checkIsSubscription(cartData);
    const cvvInfoPopupShown = useAppSelector(store => store.newCreditCard.cvvInfoPopupShown);

    return (
        <div className="mb-10">

            {
                isZeroPurchase && (
                    <div className="info-box mb-4"><p>Your order total is $0, therefore no payment information is required.</p></div>
                )
            }

            {
                !isZeroPurchase &&
                <>
                    <PaymentTabs />

                    {
                        isCreditCardSelected && isSubscription &&
                        <GrayBox classes="mb-4">All major credit cards accepted. Subscriptions cannot be purchased with debit/prepaid cards.</GrayBox>
                    }

                    { isCreditCardSelected && selectedCreditCardTab === CreditCardTabTabsEnum.NewCreditCard && <NewCreditCard /> }
                    { isCreditCardSelected && selectedCreditCardTab === CreditCardTabTabsEnum.SavedCreditCards && <SavedCreditCards /> }

                    {
                        isPayPalSelected && (
                            <div className="bg-gray-100 border rounded text-gray-700 py-4 px-6">
                                Once you click { isSubscription ? 'Agree and Subscribe' : 'Confirm Order' } you will be redirected to PayPal. Once you have completed payment on PayPal you will be redirected back to waves.com.
                            </div>
                        )
                    }

                    {
                        isAliPaySelected && (
                            <div className="bg-gray-100 border rounded text-gray-700 py-4 px-6">
                                Once you click { isSubscription ? 'Agree and Subscribe' : 'Confirm Order' } you will be redirected to AliPay. Once you have completed payment on AliPay you will be redirected back to waves.com.
                            </div>
                        )
                    }
                </>
            }

            {
                cvvInfoPopupShown &&
                <CVVInfoPopup onClose={ () => {
                    dispatch(
                        newCreditCardActions.main({
                            cvvInfoPopupShown: false,
                        })
                    );
                }} />
            }
        </div>
    )
};

export default Payment;